"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagePropsAuth = exports.getAuthPageProp = void 0;
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const AUTH_PAGE_PROP = '_usr';
function getAuthPageProp(pageProps) {
    return (0, get_1.default)(pageProps, [`props`, AUTH_PAGE_PROP], (0, get_1.default)(pageProps, [AUTH_PAGE_PROP], null));
}
exports.getAuthPageProp = getAuthPageProp;
function usePagePropsAuth(pageProps) {
    return (0, react_1.useMemo)(() => getAuthPageProp(pageProps), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getAuthPageProp(pageProps)]);
}
exports.usePagePropsAuth = usePagePropsAuth;
//# sourceMappingURL=getAuthPageProp.js.map